var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditPublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit-public_svg__clip0_1060_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.027 10.75a.63.63 0 00.093-.008l2.628-.46a.153.153 0 00.083-.044l6.624-6.624a.155.155 0 00.034-.17.155.155 0 00-.034-.05L9.858.795A.155.155 0 009.747.75a.155.155 0 00-.111.045L3.013 7.42a.159.159 0 00-.044.083l-.461 2.628a.523.523 0 00.147.465.53.53 0 00.372.155zM4.08 8.025l5.667-5.666 1.145 1.146L5.225 9.17l-1.39.246.245-1.391zm8.67 4.037H1.25a.5.5 0 00-.5.5v.563c0 .069.056.125.125.125h12.25a.125.125 0 00.125-.125v-.563a.5.5 0 00-.5-.5z",
    fill: "currentColor"
  }))));
}

export default SvgEditPublic;